export const onRowPrepared = (input) => {
    if (input?.rowType === 'data') {
        if (!input.data.isPortfolio) {
            if (input.cells && input.cells.length > 0 && input.cells[0]?.cellElement) {
                input.cells[0].cellElement.classList.remove('dx-datagrid-closed');
                input.cells[0].cellElement.classList.remove('dx-datagrid-expand');
                input.cells[0].cellElement.childNodes[0].classList.remove('dx-datagrid-group-closed');
                input.cells[0].cellElement.childNodes[0].classList.remove('dx-datagrid-group-opened');
            }
        }
    }
};
